import React, { useState } from "react";
import axios from "axios";
import API_ENDPOINTS from '../../utils/apiEndpoints';
import { useNavigate } from "react-router-dom";

const ChangePassword = () => {
    const [oldPassword, setOldPassword] = useState("");
    const [newPassword, setNewPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [message, setMessage] = useState("");
    const [isError, setIsError] = useState(false);
    const [passwordChanged, setPasswordChanged] = useState(false);
    const navigate = useNavigate();

    const handleChangePassword = async () => {
        setMessage("");
        setIsError(false);
        setPasswordChanged(false);

        try {
            const token = localStorage.getItem("adminToken");
            // const token ="60|axvXzLrrTqCOmArof8qZNHOhSVf0ZzdqO3hZN6u93740398f";

            const response = await axios.post(API_ENDPOINTS.ADMIN_PASS_CHANGE,
                {
                    old_password: oldPassword,
                    new_password: newPassword,
                    confirm_password: confirmPassword,
                },
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );

            setMessage(response.data.message); // Show success message
            setOldPassword("");
            setNewPassword("");
            setConfirmPassword("");
            setPasswordChanged(true);
            setIsError(false);
        } catch (err) {
            if (err.response?.data) {
                const errorData = err.response.data;
                let errorMessage = errorData.message || "Something went wrong.";

                if (errorData.data) {
                    const errors = Object.values(errorData.data).flat();
                    errorMessage = errors.join(" ");
                }

                setMessage(errorMessage);
                setIsError(true);
            } else {
                setMessage("Something went wrong.");
                setIsError(true);
            }
        }
    };

    const handlepasschange = () => {
        localStorage.setItem("adminToken", "");
        localStorage.setItem("adminRole", "");
        // alert("Logging out");
        navigate("/admin/login");
      };

    return (
        
        <div className="w-screen min-h-screen flex items-center justify-center bg-gray-50 px-4 sm:px-6 lg:px-8">
            <div className="relative py-3 sm:max-w-xs sm:mx-auto">
                <div className="min-h-96 px-8 py-6 mt-4 text-left bg-white rounded-xl shadow-lg">
                    <div className="flex flex-col justify-center items-center h-full select-none">
                        <div className="flex flex-col items-center justify-center gap-2 mb-8">
                            <p className="m-0 text-[16px] font-semibold">Change Password</p>
                        </div>

                        {message && (
                            <p className={`text-xs ${isError ? "text-red-500" : "text-green-500"}`}>
                                {message}
                            </p>
                        )}

                        <div className="w-full flex flex-col gap-2">
                            <label className="font-semibold text-xs text-gray-400">Old Password</label>
                            <input
                                className="border rounded-lg px-3 py-2 mb-2 text-sm w-full outline-none"
                                type="password"
                                placeholder="Enter old password"
                                value={oldPassword}
                                onChange={(e) => setOldPassword(e.target.value)}
                            />

                            <label className="font-semibold text-xs text-gray-400">New Password</label>
                            <input
                                className="border rounded-lg px-3 py-2 mb-2 text-sm w-full outline-none"
                                type="password"
                                placeholder="Enter new password"
                                value={newPassword}
                                onChange={(e) => setNewPassword(e.target.value)}
                            />

                            <label className="font-semibold text-xs text-gray-400">Confirm Password</label>
                            <input
                                className="border rounded-lg px-3 py-2 mb-5 text-sm w-full outline-none"
                                type="password"
                                placeholder="Confirm new password"
                                value={confirmPassword}
                                onChange={(e) => setConfirmPassword(e.target.value)}
                            />

                            <button
                                onClick={handleChangePassword}
                                className="py-1 px-8 bg-blue-500 hover:bg-blue-800 focus:ring-offset-blue-200 text-white w-full transition ease-in duration-200 text-center text-base font-semibold shadow-md focus:outline-none focus:ring-2 focus:ring-offset-2 rounded-lg cursor-pointer select-none"
                            >
                                Change Password
                            </button>
                            {passwordChanged && (
    <button 
        onClick={handlepasschange} 
        className="mt-4 py-1 px-8 bg-gray-500 hover:bg-gray-700 text-white transition ease-in duration-200 text-center text-base font-semibold shadow-md focus:outline-none focus:ring-2 focus:ring-offset-2 rounded-lg cursor-pointer select-none"
    >
        Go Back
    </button>
)}

                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ChangePassword;
